<div class="wrap">
  <div class="header">
    <div class="logo">
      <app-svg-icon
        [name]="'logo-small'"
        [color]="'color-surface'"
      ></app-svg-icon>
    </div>
    <div class="greeting">{{ "@pages.login.greeting" | translate }}</div>
    <div class="brand">Chill&Bite</div>
  </div>
  <div class="content">
    <div class="title">{{ "@pages.forgotPassword.title" | translate }}</div>
    <div class="form">
      <form-item>
        <app-input
          [control]="form.controls.email"
          [iconName]="'email'"
          [label]="'@pages.login.form.email.label' | translate"
          [placeholder]="'@pages.login.form.email.placeholder' | translate"
        ></app-input>
        <div
          *ngIf="form.controls.email.touched && !form.controls.email.value"
          class="input-error-message"
        >
          {{ "@pages.login.form.errors.emailEmpty" | translate }}
        </div>
        <div
          *ngIf="
            form.controls.email.touched &&
            form.controls.email.value &&
            form.controls.email.invalid
          "
          class="input-error-message"
        >
          {{ "@pages.login.form.errors.emailInvalid" | translate }}
        </div>
      </form-item>
    </div>
    <div class="action-btn mb">
      <app-action-button
        (click)="onResetPasswordClick()"
        [label]="'@pages.forgotPassword.actionBtn' | translate"
        [endIconName]="'arrow-right'"
        [disabled]="form.invalid || form.pristine"
        [isLoading]="(loader.isLoading$ | async)!"
      ></app-action-button>
      <app-action-button
        (click)="onCancelClick()"
        [label]="'@pages.forgotPassword.cancel' | translate"
        [isOutlined]="true"
      ></app-action-button>
    </div>
    <div class="instruction">{{ "@pages.forgotPassword.instruction" | translate }}</div>
  </div>
</div>
